import { ProductService } from './../../../../configurations/inventory/product/product.service';
import { FormControlList, FormControlListIds } from './../../constants/formcontrol-list.constants';
import { SharedCRMConfigService } from './../../../../configurations/crm/shared/services/shared-crm-config.service';
import { ConfigurationService } from './../../../../configurations/configurationService';
import { ObjectNames } from './../../../../shared/constants';
import { SharedChannelService } from './../../services/channel.service';
import { AppMainService } from './../../../../app-main.service';
import { Component, OnInit, OnDestroy, Output, EventEmitter, Input, ViewChild } from "@angular/core";
import { Subject, takeUntil } from "rxjs";
import { AccountModuleId, CaseModuleId, ContactModuleId, LeadModuleId, ProductModuleId, SOModuleId, workspaceModuleId,JournalModuleId, InvoiceOrderModuleId, CMOrderModuleId } from "../../constants/modules.constant";
import { FeatureSubscriptionInfoEnums } from "../../enums/feature-subscription-info.enum";
import { SubscriptionFeatureLimitM } from "../../models/organization-subscription/subscription-feature-limit.modal";
import { MessageService } from "primeng/api";
import { OrganizationSubscriptionService } from '../../services/organization-subscription.service';

//Excel Imports
import { utils as XLSXUtils, read } from "xlsx";
import * as XLSX from 'xlsx';
import { WorkspaceService } from 'src/app/misc/workspace/services/workspace.service';
import { WorkbookList, WorkSpaceList } from 'src/app/misc/workspace/models/workspace.models';
import { ColumnDefinition } from '../../models/dynamic-table/dynamic-table-data.model';
import { DynamicTableService } from '../../services/dynamic-table/dynamic-table.service';
import { FileUpload } from 'primeng/fileupload';

interface DropdownListM { id: number; name: string; }

@Component({
    selector: "app-shared-import-modal",
    styleUrls: ["./shared-import-modal.component.scss"],
    templateUrl: "./shared-import-modal.component.html",
})
export class SharedImportModalComponent implements OnInit, OnDestroy {

    protected ngUnsubscribe$: Subject<void> = new Subject<void>();

    @Input() selectedModuleId: number = 0;
    @Input() selectedChannelId: number = 0;
    @Input() disableModuleChange: boolean = false;
    @Input() displayAddImport: boolean = false;
    @Input() selectedWorkspaceId: string;
    @Input() selectedWorkbookId: string;
    @Output() dialogClosed = new EventEmitter();
    @Output() importStarted = new EventEmitter();

    subscriptionLimit: SubscriptionFeatureLimitM|null = null;
    workspaceModuleId = workspaceModuleId;
    contactModuleId = ContactModuleId;
    journalModuleId = JournalModuleId;
    SOModuleId = SOModuleId;
    invoiceOrderModuleId = InvoiceOrderModuleId;
    cmOrderModuleId = CMOrderModuleId;
    dialogHeader: string = "Import Data";
    importModules: DropdownListM[] = [
        {id: AccountModuleId, name: 'Account'},
        {id: LeadModuleId, name: 'Lead'},
        {id: CaseModuleId, name: 'Cases'},
        {id: ContactModuleId, name: 'Contact'},
        {id: ProductModuleId, name: 'Product'},
        {id: SOModuleId, name: 'Sales Order'},
        {id: InvoiceOrderModuleId, name: 'Invoice'},
        {id: CMOrderModuleId, name: 'Credit Memo'},
        {id: workspaceModuleId, name: 'Workspace'},
        {id: JournalModuleId, name: 'Journal'},
    ];
    selectedModule: DropdownListM|null = null;
    moduleChannels: DropdownListM[] = [];
    productTemplates: any[] = [];
    productSectionNames: any[] = [];
    selectedChannel: DropdownListM|null = null;

    //** Sales order modules varaibles */
    inventoryOrderTemplates: any[] = [];
    inventoryOrderSectionNames: any[] = [];



    displayImportSample: boolean = false;
    sectionColumns: any[] = [];

    importActions: {name: string, value: string}[] = [
        {
            name: 'Add',
            value: 'add'
        },
        {
            name: 'Update',
            value: 'edit'
        },
        {
            name: 'Add and Update',
            value: 'addedit'
        }
    ];

    selectedAction = this.importActions[0];

    displayFieldMapping: boolean = false;
    uploadedFiles: any[] = [];
    importFiles: any[] = [];
    selectedFile: File|null = null;
    selectedFileHeaders: {
        excelHeader: string;
        excelColumn: string;
        columnNumber: number;
        moduleField: any
    }[] = [];
    //** Workspace import variables */
    worspaceList: WorkSpaceList[] = [];
    selectedWorkspace: WorkSpaceList|null = null;
    workBookList: WorkbookList[] = [];
    selectedWorkbook:WorkbookList|null = null;
    workbookColumns: ColumnDefinition[] = [];

    @ViewChild('uploader') uploader!: FileUpload;

    constructor(
        private messageService: MessageService,
        private appMainService: AppMainService,
        private sharedChannelService: SharedChannelService,
        private productService: ProductService,
        private configService: ConfigurationService,
        private sharedConfigService: SharedCRMConfigService,
        private organizationSubscriptionService: OrganizationSubscriptionService,
        private readonly workspaceService: WorkspaceService,
        private readonly dynamicTableService: DynamicTableService
    ){

    }

    ngOnInit(): void {
        this.checkSubscriptionLimit();
        this.setSelectedModule();
    }

    checkSubscriptionLimit(){
        // this.appMainService.isShowSpinner('checkSubscriptionLimit');
        this.organizationSubscriptionService
        .getFeatureSubscriptionInfo(FeatureSubscriptionInfoEnums.Import).subscribe({
            next: (response)=>{
                this.subscriptionLimit = response;
                this.appMainService.isHideSpinner('checkSubscriptionLimit');
            },
            error: (error)=>{
                this.appMainService.isHideSpinner('checkSubscriptionLimit');
            }
        })
    }

    get subscriptionLimitReached(){
        return (this.subscriptionLimit?.allowedLicence && this.subscriptionLimit?.allowedLicence<=this.subscriptionLimit?.consumedLicense)
    }

    //#region import module selection

    setSelectedModule(){
        if(this.selectedModuleId){
            this.selectedModule = this.importModules.find(m=> m.id==this.selectedModuleId)||null;
            this.getChannels();
        }
    }

    getChannels(){
        this.selectedAction = this.importActions[0];
        this.selectedChannel = null;
        if(this.selectedModule?.id==ProductModuleId){
            this.getProductChannels();
        }else if(this.selectedModule?.id==workspaceModuleId){
            this.getWorkspaceList();
        }else if([InvoiceOrderModuleId,CMOrderModuleId,SOModuleId].includes(this.selectedModule?.id)){
            this.getInventoryChannels();
        }else if(this.selectedModule?.id==JournalModuleId){
            this.moduleChannels = [{id: 1, name: 'Default Channel'}];
            this.selectedChannel = this.moduleChannels[0];
        }else{
            this.getCRMChannels(this.selectedModule?.id||0);
        }
    }

    getWorkspaceList() {
        this.appMainService.isShowSpinner('getWorkspaceList');
        this.workspaceService
          .getWorkspaceList()
          .pipe(takeUntil(this.ngUnsubscribe$))
          .subscribe({
            next: (response: WorkSpaceList[]) => {
              this.appMainService.isHideSpinner('getWorkspaceList');
              this.worspaceList = response;
                if(this.selectedWorkspaceId){
                    this.selectedWorkspace = this.worspaceList.find(w=> w?.id==this.selectedWorkspaceId)||null;
                    this.getWorkbookList(this.selectedWorkspace.id);
                }
            },
            error: (error) => {
              this.appMainService.isHideSpinner('getWorkspaceList');
            },
          });
      }

      onWorkspaceChange(){
        this.getWorkbookList(this.selectedWorkspace.id)
      }

      getWorkbookList(workspaceId) {
        this.appMainService.isShowSpinner('getWorkbookList');
        this.workspaceService
          .getWorkspaceItemsDetailsByID(workspaceId)
          .pipe(takeUntil(this.ngUnsubscribe$))
          .subscribe({
            next: (response) => {
              this.appMainService.isHideSpinner('getWorkbookList');
              if(this.selectedWorkbookId){
                this.selectedWorkbook = response.find(w=> w.id==this.selectedWorkbookId)||null;
              }
              this.workBookList = response;

            },
            error: (error) => {
              this.appMainService.isHideSpinner('getWorkbookList');
            },
          });
      }

    getCRMChannels(moduleId: number): void {
        this.appMainService.isShowSpinner('getAccountLeadChannels');
        this.sharedChannelService.getChannels(moduleId, [CaseModuleId].includes(moduleId))
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: (response) => {
                    this.moduleChannels = response || [];
                    this.selectedChannel = null;
                    if (this.selectedChannelId) {
                        this.selectedChannel = this.moduleChannels.find(channel => channel.id === this.selectedChannelId)||null;
                    }else if(moduleId==ContactModuleId && this.moduleChannels?.length>0){
                        this.selectedChannel = this.moduleChannels[0];
                    }

                    this.appMainService.isHideSpinner('getAccountLeadChannels');
                },
                error: (error) => {
                    this.appMainService.isHideSpinner('getAccountLeadChannels');
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: error?.error?.message ? error?.error?.message : 'Channels are not loaded, please try again...'
                    });
                }
            });
    }

    getProductChannels(){
        const moduleName = "product";
        const channelName = ObjectNames.CHANNEL_PRODUCT_CONFIGURATION;
        const templateName = ObjectNames.TEMPLATE_PRODUCT_CONFIGURATION;
        const sectionName = ObjectNames.SECTION_PRODUCT_CONFIGURATION;

        this.appMainService.isShowSpinner("getModuleConfigs");

        this.configService.getConfigurationsByModuleName(moduleName).subscribe(
            (configs) => {
                this.appMainService.isHideSpinner("getModuleConfigs");

                let configJSONValueProduct = configs.filter((s) => s.name == channelName && s.typeId == 96)[0]?.configurationDetails[0]?.configJSONValue;
                const allChannels = configJSONValueProduct ? JSON.parse(configJSONValueProduct) : [];
                this.moduleChannels = allChannels.filter(ch => [1, 2, 3].includes(ch.id));
                let templateConfig = configs.filter((s) => s.name == templateName && s.categoryId == 6)[0];
                this.productTemplates = JSON.parse(templateConfig.configurationDetails[0].configJSONValue);
                let productSection = configs.filter((s) => s.name == sectionName)[0];
                this.productSectionNames = JSON.parse(productSection.configurationDetails[0].configJSONValue);

                if (this.selectedChannelId) {
                    this.selectedChannel = this.moduleChannels.find(channel => channel.id === this.selectedChannelId)||null;
                }
            },
            () => {
                this.appMainService.isHideSpinner("getModuleConfigs");
            }
        );
    }

    getInventoryChannels(){
        const moduleName = "order";
        const templateName = "Orders Template";
        const sectionName = "Order Section";

        this.appMainService.isShowSpinner("getModuleConfigs");

        this.configService.getConfigurationsByModuleName(moduleName).subscribe(
            (configs) => {
                this.appMainService.isHideSpinner("getModuleConfigs");
                let configJSONValueProduct = configs.filter((s) => s.name == templateName && s.categoryId == 6)[0]?.configurationDetails[0]?.configJSONValue;
                const allChannels = configJSONValueProduct ? JSON.parse(configJSONValueProduct) : [];
                this.selectedChannel = allChannels;
                let templateConfig = configs.filter((s) => s.name == templateName)[0];
                this.inventoryOrderTemplates = JSON.parse(templateConfig.configurationDetails[0].configJSONValue);
                let salesOrderSection = configs.filter((s) => s.name == sectionName)[0];
                this.inventoryOrderSectionNames = JSON.parse(salesOrderSection.configurationDetails[0].configJSONValue);
            },
            () => {
                this.appMainService.isHideSpinner("getModuleConfigs");
            }
        );
    }



    getDisableValues():boolean{
        if(this.selectedModule?.id && (this.selectedChannel || this.selectedModule?.id==ContactModuleId || this.selectedWorkbook || [InvoiceOrderModuleId,CMOrderModuleId,SOModuleId].includes(this.selectedModule?.id))){
            return false;
        }

        return true;
    }

    downloadSampleFile(){
        if(this.selectedModule?.id==ProductModuleId){
            this.getProductColumns('sample');
        }else if(this.selectedModule?.id==workspaceModuleId){
            this.getWorkbookColumn('sample');
        }
        else if([SOModuleId].includes(this.selectedModule?.id)){
            this.getInventoryOrderColumns('sample');
        }else if([InvoiceOrderModuleId,CMOrderModuleId].includes(this.selectedModule?.id)){
            this.checkPostingPeriodEnabled('sample');
        }else if(this.selectedModule?.id==JournalModuleId){
            this.getJournalColumns('sample');
        }else{
            this.getCRMColumns('sample');
        }
    }

    mapImportField(){
        if(this.selectedModule?.id==ProductModuleId){
            this.getProductColumns('mapping');
        }else if(this.selectedModule?.id==workspaceModuleId){
            this.getWorkbookColumn('mapping');
        }else if([SOModuleId].includes(this.selectedModule?.id)){
            this.getInventoryOrderColumns('mapping');
        }else if([InvoiceOrderModuleId,CMOrderModuleId].includes(this.selectedModule?.id)){
            this.checkPostingPeriodEnabled('mapping');
        }else if(this.selectedModule?.id==JournalModuleId){
            this.getJournalColumns('mapping');
        }else{
            this.getCRMColumns('mapping');
        }
    }
    // #region CRM Columns
    getCRMColumns(modalType: 'sample'|'mapping'): void {
        this.appMainService.isShowSpinner("getCRMColumns");
        this.sharedConfigService.getTemplateImportFields(this.selectedModule?.id||0, this.selectedChannel?.id||0)
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: (response: any) => {
                    this.appMainService.isHideSpinner("getCRMColumns");
                    this.sectionColumns = response;
                    const notForImport = ['createdByUserName','createdByName', 'createdDate', 'updatedDate', 'updatedByUserName','updatedByName', 'previousStage', 'stageChangedBy', 'stageChangedDate','leadGrade','leadScore','scoreTrend', 'taskDueDate', 'taskOverDueDate', 'lastEventDate', 'lastActivityDate', 'latestEventDate'];
                    const notForImportControls = [FormControlList.FileUpload,FormControlList.Picture,FormControlList.AutoNumber,FormControlList.Formula];

                    this.sectionColumns.map(section => {
                        section.customFields.map(field => {
                            field['isCustom'] = true;
                        });
                        section.fields.push(...section.customFields);
                        section.fields = section.fields
                            .filter(field => field.enabledInForm) // Keep only fields with enabledInForm as true
                            .filter(field => !notForImport.includes(field.field) && !notForImportControls.includes(field?.formControl?.type || field?.formControl))
                            .map(field => {
                                if (field.childFields?.length > 0) {
                                    field.childFields = field.childFields
                                        .filter(childField => childField?.enabledInForm) // Keep only child fields with enabledInForm as true
                                        .filter(childField => !notForImport.includes(childField.field) && !notForImportControls.includes(childField?.formControl?.type || childField?.formControl));
                                }
                                return field;
                            });
                        section.fields.map((fieldData) => {

                            fieldData.isRequired = false;
                            fieldData.isDisabled = false;

                            if (this.selectedAction?.value == 'add' && ['contactFirstName', 'firstName'].includes(fieldData.field) && [LeadModuleId, AccountModuleId].includes(this.selectedModule?.id)) {
                                fieldData.enabledInForm = true;
                                fieldData.isRequired = true;
                                fieldData.isDisabled = true;
                            }

                            if (this.selectedAction?.value == 'add' && ['contactAssociation', 'businessName', 'firstName'].includes(fieldData.field) && [ContactModuleId].includes(this.selectedModule?.id)) {
                                fieldData.enabledInForm = true;
                                fieldData.isRequired = true;
                                fieldData.isDisabled = true;
                            }

                            if (this.selectedAction?.value != 'add' && ['sequenceNumber'].includes(fieldData.field) && [ContactModuleId].includes(this.selectedModule?.id)) {
                                fieldData.enabledInForm = true;
                                fieldData.isRequired = true;
                                fieldData.isDisabled = true;
                            }

                            fieldData['ischecked'] = fieldData.enabledInForm || false;
                            fieldData['custom'] = fieldData?.isCustom || false;

                            if (fieldData.childFields?.length > 0) {
                                fieldData.childFields = fieldData.childFields
                                    .filter(field => field.enabledInForm) // Keep only child fields with enabledInForm as true
                                    .filter(field => !notForImport.includes(field.field) && !notForImportControls.includes(field?.formControl?.type || field?.formControl));
                                fieldData.childFields.map(childField => {
                                    childField['ischecked'] = childField.enabledInForm || false;
                                    childField['custom'] = childField?.isCustom || false;
                                    childField['isRequired'] = false;
                                    childField['isDisabled'] = false;
                                });
                            }
                        });
                    });
                    if(modalType=='sample'){
                        this.displayImportSample = true;
                    }else{
                        this.displayFieldMapping = true;
                    }
                },
                error: (error)=>{
                    this.appMainService.isHideSpinner("getCRMColumns");
                }
            });
    }
    // #endregion CRM Columns

    // #region Product Columns
    getProductColumns(modalType: 'sample'|'mapping'){

        const allSectionName = this.productSectionNames.filter(section => section.typeId === this.selectedChannel.id);
        const fillterFeilds = this.productTemplates.find(section => section.producttypeId === allSectionName[0].typeId);

        this.sectionColumns = allSectionName.map((data) => {
            let dataRes = {}
            dataRes['id'] = data?.id;
            dataRes['name'] = data.name;
            dataRes['fields'] = fillterFeilds[data.code];
            dataRes['customFields'] = [];

            dataRes['fields'].map(col=>{
                col['field'] = col.code;
                col['labelName'] = col.labelname || col.name;
                col['ischecked'] = col.isChecked || false;
               // col['isRequired'] = (col?.IsRequired || col?.isRequired || false);
               col['isRequired'] = col.code === "itemno";
               col['isDisabled'] = col.code === "itemno";     // only Item No is mandatory
                col['pickListValues'] = col?.pickupList||[];

                if (col.childFields?.length) {
                    col['showChildrens'] = false;

                    col.childFields.map(childCol=> {
                        childCol['field'] = childCol.code;
                        childCol['labelName'] = childCol?.labelname || childCol?.name;
                        childCol['ischecked'] = childCol?.isChecked || false;
                        childCol['isRequired'] = false;//(childCol?.IsRequired || childCol?.isRequired || false);
                        childCol['pickListValues'] = childCol?.pickupList||[];
                    })
                }
            });

            return dataRes;
        });

        if(modalType=='sample'){
            this.displayImportSample = true;
        }else{
            this.displayFieldMapping = true;
        }
    }
    // #endregion Product Columns

    // #region Sales Order Columns
    checkPostingPeriodEnabled(modalType: 'sample'|'mapping') {
        this.appMainService.isShowSpinner("checkPostingPeriodEnabled");
        this.productService.loadISettings().pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
            next: (response) => {
                this.appMainService.isHideSpinner("checkPostingPeriodEnabled");
                const isPostingPeriodEnabled = (response||[]).find(setting => setting.code === 'posting')?.enabled || false;
                this.getInventoryOrderColumns(modalType, isPostingPeriodEnabled);
            },
            error: (error) => {
                this.appMainService.isHideSpinner("checkPostingPeriodEnabled");
                this.getInventoryOrderColumns(modalType, false);
            }
        })
    }

    getInventoryOrderColumns(modalType: 'sample'|'mapping', isPostingPeriodEnabled: boolean = false) {

        let typeId = 0;
        let showPostingPeriod = false;

        switch(this.selectedModule?.id){
            case SOModuleId:
                typeId = 3;
                break;
            case InvoiceOrderModuleId:
                typeId = 4;
                showPostingPeriod = isPostingPeriodEnabled;
                break;
            case CMOrderModuleId:
                typeId = 6;
                showPostingPeriod = isPostingPeriodEnabled;
                break;
        }

        let allSectionName = this.inventoryOrderSectionNames.filter(section => [0, typeId].includes(section.typeId)); // TypeID is 0 for Default Channel for now
        allSectionName = allSectionName.filter((column, index, self) =>
            index === self.findIndex((c) => c.code === column.code)
        );
        const fillterFeilds = this.inventoryOrderTemplates.find(section => section.typeId === typeId);
        const notForImport = ['subtotal','ordertotal','signature','terms','createdby','atp','pick','pack','shipqty','backorderqty'];
        const notForImportControls = [FormControlListIds.FileUpload,FormControlListIds.Picture,FormControlListIds.Formula];
        const mandatoryFieldsForAdd = ['accountid', 'item', 'qty'];
        const mandatoryFieldsForUpdate = ['salesno', 'memono', 'item'];

        this.sectionColumns = allSectionName.map((data) => {
            let dataRes = {}
            dataRes['id'] = data?.id;
            dataRes['name'] = data.name;
            dataRes['fields'] = fillterFeilds[data.code];
            dataRes['fields'] = data.code=='labels_billaddress' ? fillterFeilds[data.code] : fillterFeilds[data.code].filter(col=> col.code!='accountid'); //hide other account id field
            dataRes['customFields'] = [];

            dataRes['fields'].map(col=>{
                if (col.name === "Payment Term" && data.code == "labels_section") {
                    col.code = "paymentterm";
                }
                else if (col.name === "Handling Fees" && data.code == "labels_table") {
                    col.code = "tblhadlingfee";
                }
                else if (col.name === "Handling Fees" && data.code == "labels_footer") {
                    col.code = "orderhadlingfee";
                }
                else {
                    col.code = col.code;
                }

                col['field'] = col.code;
                col['labelName'] = col.labelname || col.name;
                col['ischecked'] = col.isChecked || false;
                col['isRequired'] = false;//(col?.IsRequired || col?.isRequired || false);
                col['isDisabled'] = false;
                col['pickListValues'] = col?.pickupList||[];

                if(mandatoryFieldsForAdd.includes(col['field']) && this.selectedAction?.value=='add'){
                    col['ischecked'] = true;
                    col['isRequired'] = true;
                    col['isDisabled'] = true;
                }

                if(mandatoryFieldsForUpdate.includes(col['field']) && this.selectedAction?.value!='add'){
                    col['ischecked'] = true;
                    col['isRequired'] = true;
                    col['isDisabled'] = true;
                }

                if (col.childFields?.length) {
                    col['showChildrens'] = false;

                    col.childFields.map(childCol=> {
                        childCol['field'] = childCol.code;
                        childCol['labelName'] = childCol?.labelname || childCol?.name;
                        childCol['ischecked'] = childCol?.isChecked || false;
                        childCol['isRequired'] = false;//(childCol?.IsRequired || childCol?.isRequired || false);
                        childCol['isDisabled'] = false;
                        childCol['pickListValues'] = childCol?.pickupList||[];

                        if(mandatoryFieldsForAdd.includes(childCol['field']) && this.selectedAction?.value=='add'){
                            childCol['ischecked'] = true;
                            childCol['isRequired'] = true;
                            childCol['isDisabled'] = true;
                        }

                        if(mandatoryFieldsForUpdate.includes(childCol['field']) && this.selectedAction?.value!='add'){
                            childCol['ischecked'] = true;
                            childCol['isRequired'] = true;
                            childCol['isDisabled'] = true;
                        }
                    })
                }
            });

            if(data.name=='Misc'){
                const miscStaticFields = [];

                if(showPostingPeriod){
                    miscStaticFields.push({
                        code: 'postingPeriod',
                        field: 'postingPeriod',
                        labelName: 'Posting Period',
                        isRequired: true,
                        ischecked: true,
                        custom: false
                    });
                }

                dataRes['fields'] = [...dataRes['fields'], ...miscStaticFields];
            }

            if(data.name=='Table'){
                const tableDiscountFields = [
                    {
                        code: 'action',
                        field: 'action',
                        labelName: 'Action',
                        isRequired: this.selectedAction?.value!='add',
                        ischecked: this.selectedAction?.value!='add',
                        isDisabled: this.selectedAction?.value!='add',
                        custom: false
                    },
                    {
                        code: 'tableDiscountRate',
                        field: 'tableDiscountRate',
                        labelName: 'Line Discount Rate',
                        isRequired: false,
                        ischecked: false,
                        custom: false
                    },
                    {
                        code: 'tableHandlingRate',
                        field: 'tableHandlingRate',
                        labelName: 'Line Handling Fee Rate',
                        isRequired: false,
                        ischecked: false,
                        custom: false
                    }
                ];

                dataRes['fields'] = [tableDiscountFields[0], ...dataRes['fields'], ...tableDiscountFields.slice(1)];
            }

            if(data.name=='Footer'){
                const tableDiscountFields = [
                    {
                        code: 'footerDiscountRate',
                        field: 'footerDiscountRate',
                        labelName: 'Footer Discount Rate',
                        isRequired: false,
                        ischecked: false,
                        custom: false
                    },
                    {
                        code: 'footerHandlingRate',
                        field: 'footerHandlingRate',
                        labelName: 'Footer Handling Fee Rate',
                        isRequired: false,
                        ischecked: false,
                        custom: false
                    }
                ];

                dataRes['fields'] = [...dataRes['fields'],...tableDiscountFields];
            }

            dataRes['fields'] = dataRes['fields'].filter(field=> !notForImport.includes(field.field) && !notForImportControls.includes(field?.formControlId));

            return dataRes;
        });

        if(modalType=='sample'){
            this.displayImportSample = true;
        }else{
            this.displayFieldMapping = true;
        }
    }
    // #endregion Sales Order Columns

    //#region Journal Columns
    getJournalColumns(modalType: 'sample'|'mapping') {
        this.appMainService.isShowSpinner("getJournalTemplateDetails");
        this.configService.getJournalTemplateDetails().pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
            next: (response) => {
                this.appMainService.isHideSpinner("getJournalTemplateDetails");
                this.sectionColumns = response;
                    const notForImport = [];
                    const notForImportControls = [FormControlList.FileUpload,FormControlList.Picture,FormControlList.AutoNumber,FormControlList.Formula];

                    this.sectionColumns.map(section => {
                        section.customFields.map(field => {
                            field['isCustom'] = true;
                        });
                        section.fields.push(...section.customFields);
                        section.fields.map((fieldData) => {
                            fieldData.isRequired = false;
                            fieldData.isDisabled = false;

                            fieldData['ischecked'] = fieldData.enabledInForm || false;
                            fieldData['custom'] = fieldData?.isCustom || false;

                            if (this.selectedAction?.value == 'add' && ['tranxId','financeAccountType', 'debit', 'credit'].includes(fieldData.field)) {
                                fieldData.enabledInForm = true;
                                fieldData.isRequired = true;
                                fieldData.isDisabled = true;
                            }

                            if (fieldData.childFields?.length > 0) {
                                fieldData.childFields = fieldData.childFields
                                    .filter(field => field.enabledInForm) // Keep only child fields with enabledInForm as true
                                    .filter(field => !notForImport.includes(field.field) && !notForImportControls.includes(field?.formControl?.type || field?.formControl));
                                fieldData.childFields.map(childField => {
                                    childField['ischecked'] = childField.enabledInForm || false;
                                    childField['custom'] = childField?.isCustom || false;
                                    childField['isRequired'] = false;
                                    childField['isDisabled'] = false;
                                });
                            }
                        });
                    });

                    if(modalType=='sample'){
                        this.displayImportSample = true;
                    }else{
                        this.displayFieldMapping = true;
                    }
            },
            error: (error) => {
                this.appMainService.isHideSpinner("getJournalTemplateDetails");
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: error?.error?.message ? error?.error?.message : 'Journal templates are not loaded, please try again...'
                });
            }
        })
    }
    //#endregion Journal Columns

    // #region Workspace Columns
    getWorkbookColumn(modalType: 'sample'|'mapping') {
        this.appMainService.isShowSpinner('getWorkbookColumn');
        this.dynamicTableService.getDynamicTableColumn(this.selectedWorkbook.id).pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
          next: (response: ColumnDefinition[]) => {
            this.appMainService.isHideSpinner('getWorkbookColumn');
            this.workbookColumns = response.filter(field => ![FormControlListIds.AutoNumber, FormControlListIds.Formula, FormControlListIds.UserLookup, FormControlListIds.FileUpload, FormControlListIds.Picture].includes(field?.formControlId));
            if(this.workbookColumns?.length==0){
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'No columns are available in the workbook for field mapping.'
                });
                return;
            }
            this.sectionColumns  = this.mapWorkbookColumnDefinitions(this.workbookColumns)
            if(modalType=='sample'){
                this.displayImportSample = true;
            }else{
                this.displayFieldMapping = true;
            }
          },
          error: (error) => {
            this.appMainService.isHideSpinner('getDynamicTableColumn');
          }
        })
      }

    mapWorkbookColumnDefinitions(columnDefinitions: ColumnDefinition[]): any[] {
    return [
        {
        customFields: [],
        fields: columnDefinitions.map((col) => ({
            id: col.id,
            name: col.name,
            labelName: col.name,
            field: col.name,
            formControlId: col.formControlId,
            formControl: col.formControlName,
            // mapObject: 'workspace',
            enabledInForm: true,
            isDateWithTime: false,
            readOnly: false,
            childFields: [],
            ischecked: true,
            custom: true,
            isRequired : false,
            isDisabled : false,
        })),
        id: 1,
        name: 'Workbook columns',
        systemGenerated: true,
        },
    ];
    }

    // #endregion Workspace Columns

    closeSampleModal(){
        this.displayImportSample = false;
    }

    closMappingModal(){
        this.displayFieldMapping = false;
    }

    onUpload($event: any) {
        for (let file of $event.files) {
            this.uploadedFiles.push(file);
        }
        this.messageService.add({
            severity: "info",
            summary: "File Uploaded",
            detail: "",
        });
    }

    onSelect(event) {
        const file = event.currentFiles[0];
        this.selectedFile = file;
        this.selectedFileHeaders = [];
        const fileReader = new FileReader();

        fileReader.readAsArrayBuffer(file);

        fileReader.onload = (e) => {
            const arrayBuffer: any = fileReader.result;
            const data = new Uint8Array(arrayBuffer);
            const arr = new Array();
            for (let i = 0; i != data.length; ++i) {
                arr[i] = String.fromCharCode(data[i]);
            }
            const bstr = arr.join("");
            const workbook: any = read(bstr, { type: "binary" });
            const firstSheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[firstSheetName];

            // Get the range of the worksheet
            const range = XLSXUtils.decode_range(worksheet['!ref']);

            // Create an array of column indices
            const columns = Array.from({ length: range.e.c - range.s.c + 1 }, (_, i) => range.s.c + i);

            // Use map to iterate over the columns and extract headers
            const headers = columns.map((col, index) => {
                const cellAddress = XLSXUtils.encode_col(col) + '1'; // Reference to column header (first row)
                const cell = worksheet[cellAddress]; // Get the cell object
                const excelColumn = XLSXUtils.encode_col(col);

                let headerValue = cell && cell.v ? cell.v : `Column (${excelColumn})`;

                // Check if the cell is a numeric value (which might be a date)
                if (cell && cell.t === 'n') {
                    // Convert Excel serial number to a date string if applicable
                    const dateValue = XLSX.SSF.format("mmm-yy", cell.v); // Formats as 'Mar-24', 'Apr-24'
                    if (dateValue) {
                        headerValue = dateValue;
                    }
                }

                return {
                    excelHeader: headerValue,  // The actual value in the cell or empty if undefined
                    excelColumn: excelColumn,  // Column reference like A, B, C, etc.
                    columnNumber: index+1,
                    moduleField: null
                };
            });

            this.selectedFileHeaders = headers;
        };
    }

    onRemove() {
        this.selectedFileHeaders = [];
    }

    onClear() {
        this.selectedFileHeaders = [];
    }

    importFileUploaded(){
        this.importStarted.emit(true);
        this.closeDialog();
    }

    //#endregion

    closeDialog(){
        this.displayAddImport = false;
        this.dialogClosed.emit(true);
    }


    shouldShowActionButtons() {
        if (!this.selectedModule) {
          return false;
        }

        // For Workspace module
        if ([this.workspaceModuleId].includes(this.selectedModule?.id)) {
          // Only show actions if both workspace and workbook are selected
          return this.selectedWorkspace && this.selectedWorkbook;
        }
        // For Contact, Sales Order, Invoice, and Credit Memo modules
        else if ([this.contactModuleId, this.SOModuleId, this.invoiceOrderModuleId, this.cmOrderModuleId].includes(this.selectedModule?.id)) {
          // Show actions immediately after module selection
          return true;
        }
        // For all other modules that require channel selection
        else {
          // Only show actions if channel is selected
          return !!this.selectedChannel;
        }
      }

    ngOnDestroy(): void {
        if (this.ngUnsubscribe$) {
            this.ngUnsubscribe$.next();
            this.ngUnsubscribe$.complete();
            this.ngUnsubscribe$.unsubscribe();
        }
    }
}
